// extracted by mini-css-extract-plugin
module.exports = {"btnIcon":"ButtonIcon_btnIcon__Crx6C"};